import React, { Component } from 'react'
import axios from 'axios'
import $ from 'jquery'
import _ from 'lodash'



function changeBackground(){
  $('body').addClass("bg-darkcyan");
}


export default class Certificado extends Component {
  constructor(props){
    super(props);
    this.state = {
      mis_certificados: [],
      error: false,
      cargando: true,
      status: -1,
      ci: "",
      ci_submited: false
    }

    this.other_data = {};

    this.requestCertificates = this.requestCertificates.bind(this);
    this.processResponse = this.processResponse.bind(this);
    this.processError = this.processError.bind(this);
    this.renderCiForm = this.renderCiForm.bind(this);
    this.ciChangeHandler = this.ciChangeHandler.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.reset = this.reset.bind(this);
    this.renderCertificates = this.renderCertificates.bind(this);
    changeBackground();
  }

  requestCertificates(){
    // obtengo los datos
    let ci = this.state.ci;
    //axios.post("http://127.0.0.1/ceis/conn_bd.php", {
    axios.post("https://aulas.ceis.com.py/static/conn_bd.php", {
      peticion: "mostrar_certificado",
      datos: { ci }
    }).then(this.processResponse).catch(this.processError);
  }

  reset(evt){
    evt.preventDefault();
    this.setState({
      mis_certificados: [],
      error: false,
      cargando: true,
      status: -1,
      ci_submited: false
    });
  }

  processResponse(response){
    console.log("response", response);
    let certificados = response.data.certificados;
    if(certificados.length === 0){
      this.setState({
        error: true,
        status: 404,
        cargando: false
      });
      return;
    }
    this.setState({
      certificados: certificados,
      cargando: false,
      error: false,
      status: 200
    });
  }

  processError(response){
    this.setState({ error: true, status: 500, cargando: false });
  }

  renderCargando(){
    return (
      <div className="container">
        <div className="alert alert-info mt-5" role="alert">
          Cargando...
        </div>
      </div>
    );
  }

  renderError(){
    switch (this.state.status) {
      case 404:
        return (
          <div className="container">
            <div className="alert alert-warning mt-5" role="alert">
              <h4 className="mb-4">No encontramos certificados para <code>{this.state.ci}</code>, verifique su CI</h4>
              <button className="btn btn-primary btn-block" onClick={this.reset}>Volver</button>
            </div>
          </div>
        );
      case 500:
        return (
          <div className="container">
            <div className="alert alert-danger mt-5" role="alert">
              Error al comunicarse con los servidores
              <button className="btn btn-primary btn-block" onClick={this.reset}>Volver</button>
            </div>
          </div>
        );
      default:

    }
    return (
      <div className="container">
        <div className="alert alert-danger mt-5" role="alert">
          Error desconocido
          <button className="btn btn-primary btn-block" onClick={this.reset}>Volver</button>
        </div>
      </div>
    );
  }

  ciChangeHandler(evt){
    let ci = evt.target.value;
    this.setState({ci});
  }

  onSubmit(evt){
    evt.preventDefault();
    this.requestCertificates();
    this.setState({ ci_submited: true });
  }

  renderCiForm(){
    return (
      <div className="container">
        <div className="card ml-25 mt-3 w-50">
          <div className="card-body text-left">
            <h3 className="card-title">Consulta de Certificados</h3>
            <h4 className="card-subtitle mb-2 text-muted">Introduzca su ci para consultar sus certificados</h4>
            <form onSubmit={this.onSubmit}>
              <div className="form-group">
                <label htmlFor="ci">CI</label>
                <input id="ci"
                  type="number"
                  name="ci"
                  value={this.state.ci}
                  onChange={this.ciChangeHandler}
                  className="form-control"/>
              </div>
              <div className="form-group">
                <button className="btn btn-primary btn-block" type="submit" value="submit">Aceptar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  renderCertificates(){
    return _.map(this.state.certificados, (certificado) => {
      return (
        <tr key={certificado.nombre_curso+certificado.fecha}>
          <td>{certificado.nombre_curso}</td>
          <td>{certificado.fecha}</td>
          <td>{certificado.direccion}</td>
          <td><a className="btn btn-secondary" href={`https://aulas.ceis.com.py/certificado/${certificado.id}/${certificado.ci}`} target="_blank">Ver Certificado</a></td>
        </tr>
      );
    });
  }

  render(){
    if(this.state.ci_submited === false){
      return this.renderCiForm();
    }
    if(this.state.error === true){
      return this.renderError();
    }
    if(this.state.cargando === true){
      return this.renderCargando();
    }
    return (
      <div className="container">
        <div className="card mt-3">
          <div className="card-body text-left">
            <h4>
              Centro de Formación y capacitación laboral CEIS
            </h4>
            <h5 className="card-subtitle mb-2 text-muted">Certificados otorgados {this.state.certificados[0].nombre} a C.I. {this.state.ci}</h5>
          </div>
          <div className="container">
            <table className="table table-striped table-bordered">
              <thead className="thead-dark">
                <tr>
                  <th>Curso</th>
                  <th>Fecha</th>
                  <th>Lugar</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.renderCertificates()}
              </tbody>
            </table>
            <div className="btn-group m-3 float-right">
              <button className="btn btn-secondary" onClick={this.reset}>Volver</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/mis_certificados.js